const theme = {
  colors: {
    body: '#fff',
    text: '#333',
    primary: '#d93f28',
    darkenPrimary: '#a52f1d',
    highlight: '#ed7600',
    border: '#ccc',

    hover: {
      primary: '#bd2008',
      highlight: '#ce6600',
    }
  },
  fontSizes: {
    extraSmall: '11px',
    small: '13px',
    normal: '16px',
    large: '18px',
    extraLarge: '22px'
  },
  borderRadius: '3px',
  containerWidth: '550px',

  breakpoints: {
    mobile: '568px',
    tablet: '768px',
    desktop: '1024',
  }
}

export default theme
